import { type ValidationRule } from '../../types';
import { ActionRequiredError } from '../../util/errors';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class TeleopRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.Teleop', 'Teleop');
  }

  /**
   * Teleoperation only functions on a robot in echo (AI) mode. Fail closed
   * (block play) while the mode is unknown or anything else, so External
   * Control and API play paths refuse the routine up front instead of the
   * step timing out obscurely at runtime. Mirrors the editor-side check in
   * `@sb/remote-control/step/teleop`.
   *
   * @throws {ActionRequiredError}
   */
  protected validate({ ctx }: CanonicalValidateArgs): void {
    if (ctx.robotOperationMode !== 'echo') {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Teleoperation requires the robot to be in Echo (AI) mode.',
      });
    }
  }
}

export const TeleopValidation: ValidationRule =
  new TeleopRule().toValidationRule();
